/**
 * Configuration for attachment handling in Ellis AI Chat Bot
 */

// Maximum file size in bytes (10 MB)
export const MAX_ATTACHMENT_SIZE = 10 * 1024 * 1024;

// Allowed file types
export const ALLOWED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/plain',
  'text/csv',
];

/**
 * Format bytes to human-readable format (e.g., "10 MB")
 */
export const formatBytes = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

/**
 * Validate file size
 * @returns error message if invalid, undefined if valid
 */
export const validateFileSize = (file: File): string | undefined => {
  if (file.size > MAX_ATTACHMENT_SIZE) {
    return `File "${file.name}" exceeds maximum size of ${formatBytes(
      MAX_ATTACHMENT_SIZE,
    )}. Actual size: ${formatBytes(file.size)}`;
  }
  return undefined;
};

/**
 * Validate file type
 * @returns error message if invalid, undefined if valid
 */
export const validateFileType = (file: File): string | undefined => {
  if (!ALLOWED_FILE_TYPES.includes(file.type)) {
    return `File type "${
      file.type || 'unknown'
    }" is not allowed. Please upload an image, PDF, or document file.`;
  }
  return undefined;
};
